export var EVENT_CHANNEL = 'media';
export var componentMetadata = {
  tableView: {
    component: 'datasourceTable'
  },
  configModal: {
    component: 'datasourceConfigModal'
  },
  generic: {
    component: 'datasource'
  }
};